/**
 * Quill'i global kapsama bağlar.
 *
 * PrimeReact Editor global kapsamda `Quill` bulamazsa `import('quill')` ile dinamik
 * yükleme yapar; bu ayrı bir webpack chunk'ı oluşturur ve ChunkLoadError'a yol açar.
 *
 * Bu modül `primereact/editor`'dan önce değerlendirilmelidir; import'lar hoist edildiği
 * için atamanın index.jsx gövdesinde yapılması yeterli olmazdı.
 */
import Quill from 'quill';

if (typeof window !== 'undefined' && !window.Quill) {
    window.Quill = Quill;
}

export default Quill;
